export default __webpack_public_path__ + "static/media/cultural.41c80de1.png";